import { AudioData } from "../data/AudioData";
import { FloatArrayAudioData } from "../data/FloatArrayAudioData";
import { Curve } from "./curves/Curve";
import { Key } from "./Key";

export class AudioBuilderContext
{
  #sleepTimerCheckSteps:number = 5000;
  get sleepTimerCheckSteps()
  {
    return this.#sleepTimerCheckSteps;
  }

  #sleepTimerDurationMS:number = 1000/60;
  get sleepTimerDurationMS()
  {
    return this.#sleepTimerDurationMS;
  }

  #sampleRate:number = 44100;
  get sampleRate(){ return this.#sampleRate; }

  #channels:number = 1;
  get channels(){ return this.#channels; }

  static create( sampleRate:number, channels:number )
  {
    let context = new AudioBuilderContext();
    context.#sampleRate = sampleRate;
    context.#channels = channels;

    return context;
  }
  
  #key:Key;
  get key(){ return this.#key; }

  setKey( key:Key)
  {
    this.#key = key;
  }

  #keyVelocity:Curve;
  get keyVelocity(){ return this.#keyVelocity; }
  
  #keyPitch:Curve;
  get keyPitch(){ return this.#keyPitch; }  

  setKeyData( velocityCurve:Curve, pitchCurve:Curve )
  {
    this.#keyVelocity = velocityCurve;
    this.#keyPitch    = pitchCurve; 
  }


  durationToSamples( duration:number )
  {
    return duration * this.#sampleRate;
  }

  samplesToDuration( samples:number )
  {
    return samples / this.#sampleRate;
  }

  frequencyToPhaseIncrement( frequency:number )
  {
    return frequency / this.#sampleRate;
  }

  createAudioData( duration:number ):AudioData
  {
    let sampleLength = this.durationToSamples( duration );
    
    let ad = FloatArrayAudioData.create( this.#channels, sampleLength );
    return ad;
  }
}